import { HStack, Icon, Stack, Tooltip } from '@chakra-ui/react';
import Button from '@components/interactive/Button';
import Body2 from '@components/typography/Body2';
import Header from '@components/typography/Header';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FilterButton = ({ label, tooltip, setPage, selectedStatus, setSelectedStatus, status, value }) => {
  return (
    <Button
      size="xl"
      variant={selectedStatus === status ? 'badge' : 'secondary'}
      onClick={() => {
        setPage('1');
        setSelectedStatus(status || '');
      }}
      p={3}
      isLoading={typeof value !== 'number' || (!value && value !== 0)}
      isDisabled={typeof value !== 'number' || (!value && value !== 0)}
    >
      <Stack textAlign="left">
        <Body2 fontSize={17}>{label}</Body2>
        <HStack w="100%" justifyContent="space-between">
          <Header as="h3">{value}</Header>
          <Tooltip label={tooltip}>
            <Icon size="sm" color="primary.500" as={FontAwesomeIcon} icon={faInfoCircle} />
          </Tooltip>
        </HStack>
      </Stack>
    </Button>
  );
};

export default FilterButton;
